import axios from 'axios';

// In development, we use relative paths (which are handled by the "proxy" in package.json to point to the live server).
// In production, we use REACT_APP_API_URL or fallback to 'https://trustserv.org'.
const baseURL = process.env.REACT_APP_SPRING_API_URL || (process.env.NODE_ENV === 'development' ? '' : (process.env.REACT_APP_API_URL || 'https://trustserv.org'));

// Create a pre-configured instance of axios
const apiClient = axios.create({
  baseURL: baseURL,
  timeout: 10000, // 10 second timeout
  headers: {
    'Content-Type': 'application/json',
  },
});

export default apiClient;